import classnames from 'classnames'
import * as React from 'react'

type ErrorStateProps = {
    description: string
    variant?: 'white' | 'gray'
    className?: string
    boxed?: boolean
}

export const ErrorState: React.FC<ErrorStateProps> = (props) => {
    const { description, variant = 'white', boxed = true } = props

    const className = classnames(
        props.className,
        'flex items-center justify-center text-center',
        {
            'rounded-xl border border-neutral-200 p-4': boxed,
            'bg-white': variant === 'white',
            'bg-neutral-50': variant === 'gray',
        }
    )

    return (
        <div className={className} data-testid="error-state-wrapper">
            <div
                className="text-body-medium text-subtle"
                data-testid="error-state-description"
            >
                <p dangerouslySetInnerHTML={{ __html: description }} />
            </div>
        </div>
    )
}
